import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import ActionDynamicInputEditor from './ActionDynamicInputEditor';

export default function ActionDynamicInputEditorWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper
      Component={ActionDynamicInputEditor}
      {...props}
    />
  );
}
